export default Object.freeze({
  CANDIDATE_NAME: 'candidateName',
  BREAK_MINUTES: 'breakMinutes',
  DELTA_MINUTES: 'deltaMinutes',
  LOCATION_NAME: 'locationName',
  CANDIDATE_HAS_SUBMITTED: 'candidateHasSubmitted',
  CLIENT_HAS_SUBMITTED: 'clientHasSubmitted',
  IS_REST_BREAK_COMPLIANT: 'isRestBreakCompliant',
  BOOKING_ID: 'bookingId',
  BOOKING_DATE_TIME: 'bookingDateTime',
  ASSIGNED_TO: 'assignedTo',
  TASK_TYPE: 'taskType',
})
